import styled, { css } from 'styled-components'
import Box from '@material-ui/core/Box'
import { CheckCircleOutline, WarningAmber } from '@styled-icons/material-rounded'
import { Button } from '@material-ui/core'

export const BoxCustomizado = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 448px;
  min-height: 226px;
  padding: 36px;
  border-radius: 8px;
  ${({ theme }) => css`
    background-color: ${theme.colors.white};
  `}
`
export const Conteudo = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: wrap;
`

export const Texto = styled.span`
  margin-top: 20px;
  text-align: center;
  line-height: 22px;
  ${({ theme }) => css`
    color: ${theme.colors.black};
  `}
`

export const Linha = styled.div`
  width: 100%;
`
export const Botoes = styled.div`
  margin-top: 50px;
`

export const BotaoSim = styled(Button)`
  margin-right: 20px !important;
`

export const IconCheck = styled(CheckCircleOutline)`
  width: 40px;
  ${({ theme }) => css`
    color: ${theme.colors.primary3};
  `}
`

export const IconErro = styled(WarningAmber)`
  ${({ theme }) => css`
    width: 40px;
    color: ${theme.colors.gray4};
  `}
`

export const TextoLoading = styled.span`
  margin-top: 90px;
`

export const Titulo = styled.h1`
  ${({ theme }) => css`
    color: ${theme.colors.darkGray};
    font-weight: ${theme.font.bold};
    font-size: ${theme.font.sizes.xlarge};
  `}
  text-align: center;
`
